import { Ipage } from './type';

export const colW = [
  40, 52, 65, 82, 95, 102, 120, 160, 200, 230, 250, 300, 350,
];
/** 起始頁 */
export const FIRST_PAGE = 1;
export const PAGE_SIZE = 10;

export const initPage: Ipage = {
  pageCount: 0,
  pageNo: FIRST_PAGE,
  pageSize: PAGE_SIZE,
  total: 0,
};

let timer: NodeJS.Timeout;
export const timerDebounce = (func: () => void, delay = 1000): void => {
  if (timer) {
    clearInterval(timer);
  }
  timer = setTimeout(func, delay);
};
